// extracted by mini-css-extract-plugin
module.exports = {"aboutIcon":"style_aboutIcon_iUtrH","logoIcon":"style_logoIcon_1vQME","list":"style_list_1uAgK"};